module.exports = __webpack_public_path__ + "img/ring_g_i_null_null.e437ac0e.png";